module.exports = __webpack_public_path__ + "img/9788990809704.64cb7d52.jpg";